import React from 'react'
import { Box, Stack, CircularProgress, Paper, Skeleton, Grid, Typography } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import useMediaQuery from '@mui/material/useMediaQuery'

function LoadingThankyou() {
  return (
    <Paper
      elevation={0}
      customBorder
      sx={{
        p: 2.4,
      }}
    >
      <Skeleton variant="rounded" height={117} />
    </Paper>
  )
}

export default LoadingThankyou
